"use strict";
exports.__esModule = true;
exports.MessageTextContent = void 0;
var react_native_1 = require("react-native");
var message_text_content_web_1 = require("./message-text-content-web");
var message_text_content_native_1 = require("./message-text-content-native");
exports.MessageTextContent = react_native_1.Platform.OS === "web" ? message_text_content_web_1.MessageTextContentWeb : message_text_content_native_1.MessageTextContentNative;
